import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import discountService from '../services/discounts';

const Discounts = () => {
  const [discounts, setDiscounts] = useState();
  const [discountName, setDiscountName] = useState('');
  const [discountValue, setDiscountValue] = useState(0);
  const [discountId, setDiscountId] = useState();
  const navigate = useNavigate();

  useEffect(() => {
    fetchDiscounts();
  }, []);

  const fetchDiscounts = async () => {
    try {
      const discounts = await discountService.getDiscounts();
      setDiscounts(discounts);
    } catch (error) {
      console.log(error);
    }
  };

  const handleValueChange = (value) => {
    if (Number(value) === NaN) {
      alert('Please enter proper number');
      setDiscountValue(0);
    } else {
      setDiscountValue(value);
    }
  };

  const handleAdd = async () => {
    if (discountName && discountValue) {
      try {
        const newDiscount = {
          name: discountName,
          value: discountValue,
        };
        const response = await discountService.addDiscount(newDiscount);
        fetchDiscounts();
      } catch (error) {
        console.log(error);
        alert(error);
      }
    }
  };
  const handleDelete = async (id) => {
    try {
      const response = await discountService.deleteDiscount(id);
      fetchDiscounts();
    } catch (error) {
      console.log(error);
      alert('something went wrong while deleting', error);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 px-4 sm:px-6 py-4">
      {/* Header Section */}
      <div className="mb-5">
        <button
          onClick={() => navigate(-1)}
          className="
            inline-flex
            items-center
            gap-2
            px-3
            py-1.5
            rounded-md
            bg-gray-200
            text-gray-700
            text-sm
            font-medium
            hover:bg-gray-300
            transition
          "
        >
          <ArrowLeft size={16} />
          Back
        </button>

        <h1 className="mt-2 text-xl sm:text-2xl font-semibold text-gray-800">
          Discounts
        </h1>
      </div>

      {/* Add Discount Section */}
      <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 sm:p-6 mb-6">
        <h2 className="text-lg font-semibold text-gray-700 mb-4">
          Add New Promocode
        </h2>

        <div className="flex flex-col md:flex-row gap-4">
          <input
            type="text"
            value={discountName}
            placeholder="Enter new promocode"
            onChange={(e) => setDiscountName(e.target.value)}
            className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
          />

          <input
            type="text"
            value={discountValue}
            placeholder="Enter discount value (%)"
            onChange={(e) => handleValueChange(e.target.value)}
            className="flex-1 border border-gray-300 rounded-lg px-4 py-2 text-sm focus:ring-2 focus:ring-blue-500 outline-none"
          />

          <button
            onClick={() => handleAdd()}
            className="
              bg-blue-600
              hover:bg-blue-700
              text-white
              px-6
              py-2
              rounded-lg
              text-sm
              font-medium
              transition-colors
              shadow-sm
              w-full
              md:w-auto
            "
          >
            Add Promocode
          </button>
        </div>
      </div>

      {/* Discounts List */}
      {discounts && (
        <div className="bg-white rounded-xl shadow-md border border-gray-200 p-4 sm:p-6">
          <h2 className="text-lg font-semibold text-gray-700 mb-4">
            Active Promocodes
          </h2>

          <div className="space-y-3">
            {discounts.map((discount) => (
              <div
                key={discount._id}
                className="
                  flex
                  flex-col
                  sm:flex-row
                  sm:items-center
                  sm:justify-between
                  gap-3
                  bg-gray-50
                  border
                  border-gray-200
                  rounded-lg
                  px-4
                  py-3
                  hover:bg-blue-50
                  transition-colors
                "
              >
                <p className="text-sm font-medium text-gray-700">
                  <span className="font-semibold text-blue-600">
                    {discount.name}
                  </span>{' '}
                  : {discount.value}%
                </p>

                <button
                  onClick={() => handleDelete(discount._id)}
                  className="
                    bg-red-600
                    hover:bg-red-700
                    text-white
                    px-4
                    py-1.5
                    rounded-md
                    text-sm
                    font-medium
                    transition-colors
                    w-full
                    sm:w-auto
                  "
                >
                  Delete
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Discounts;
